import React from 'react';
import PropTypes from 'prop-types';
import UserController from '../../controllers/UserController';
import moment from 'moment';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { Link } from 'react-router-dom';
import {
	Button,
	Grid,
	Container,
	Typography,
	ListItemAvatar,
	Avatar,
	ListItemText,
	ListItem,
	List,
	Card,
} from '@material-ui/core';
import { askForPermissionToReceiveNotifications } from '../../helpers/PushNotifications';
import { Alert } from '../../components/Common/Alert';
import { isNullOrUndefined } from '../../helpers/Utils';
import { LoadingOverlay } from '../../components/Common/LoadingOverlay';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import MailIcon from '@material-ui/icons/Mail';
import WorkIcon from '@material-ui/icons/Work';

function Profile(props) {
	const [email, setEmail] = React.useState(null);
	const [roles, setRoles] = React.useState(null);
	const [warningText, setWarningText] = React.useState(null);
	const [hideEmailButton, setHideEmailButton] = React.useState(false);
	const [emailConfirmed, setEmailConfirmed] = React.useState(false);
	const [hasTwoFactorAuth, setHasTwoFactorAuth] = React.useState(false);
	const [joined, setJoined] = React.useState('');
	const [emailConfirmationSent, setEmailConfirmationSent] = React.useState(false);
	const [loading, setLoading] = React.useState(true);

	// initialise
	React.useEffect(() => {
		async function init() {
			if (!props.Auth.isAuthenticated) {
				props.PushHistory('/Login');
				return;
			}
			const response = await UserController.getUserInfo();
			if (!response.hasError) {
				const { email, emailConfirmed, joined, hasTwoFactor } = response.data;
				setEmail(email);
				setEmailConfirmed(emailConfirmed);
				setJoined(joined);
				setHasTwoFactorAuth(hasTwoFactor);
				setRoles(props.Auth.role);
			} else {
				setWarningText(response.data);
			}
			setLoading(false);
		}
		init();
	}, [props]);

	async function requestNewEmailConfirmation() {
		setHideEmailButton(true);
		setWarningText(null);
		const response = await UserController.requestEmailConfirmation();
		if (!response.hasError) {
			setEmailConfirmed(false);
			setEmailConfirmationSent(true);
		} else {
			setEmailConfirmed(false);
			setHideEmailButton(false);
			setWarningText(response.data);
		}
	}

	function buildListItem(icon, primary, secondary = null) {
		return (
			<ListItem dense>
				<ListItemAvatar>
					<Avatar>{icon}</Avatar>
				</ListItemAvatar>
				<ListItemText primary={primary} secondary={secondary} />
			</ListItem>
		);
	}

	function buildEmailRequestLink() {
		const emailSent = !(!emailConfirmed && !hideEmailButton && !emailConfirmationSent);
		return (
			<Button variant="contained" onClick={requestNewEmailConfirmation} fullWidth disabled={emailSent}>
				{emailSent ? 'Email Sent' : 'Request Email Confirmation'}
			</Button>
		);
	}

	function buildRolesDisplay() {
		let rolesDisplay;
		if (!isNullOrUndefined(roles) && roles.length > 0) {
			rolesDisplay = roles.map((element, i) => (
				<span key={i}>
					{element}
					{i < roles.length - 1 ? ', ' : ''}
				</span>
			));
		}
		return rolesDisplay ?? 'No Roles';
	}

	return (
		<Container maxWidth="xs">
			<LoadingOverlay loading={loading} />

			<Typography variant="h3" align="center" gutterBottom>
				Profile
			</Typography>

			<Grid container spacing={3}>
				<Grid item xs={12}>
					<Card>
						<List>
							{buildListItem(<MailIcon />, email, emailConfirmed ? 'Confirmed' : 'Not Confirmed')}
							{buildListItem(<AccessTimeIcon />, 'Date Joined', moment(joined).format('Do MMMM YYYY'))}
							{buildListItem(<WorkIcon />, 'Roles', buildRolesDisplay())}
						</List>
					</Card>
				</Grid>
				<Grid item xs={12}>
					<Alert text={warningText} />
				</Grid>
				<Grid item xs={12}>
					<Button component={Link} to="/ChangePassword" variant="contained" fullWidth>
						Change Password
					</Button>
				</Grid>
				<Grid item xs={12}>
					<Button component={Link} to="/ChangeEmail" variant="contained" fullWidth>
						Change Email
					</Button>
				</Grid>
				<Grid item xs={12}>
					{buildEmailRequestLink()}
				</Grid>
				<Grid item xs={12}>
					<Button onClick={askForPermissionToReceiveNotifications} variant="contained" fullWidth>
						Request Push Notifications
					</Button>
				</Grid>
				<Grid item xs={12}>
					<Button component={Link} to="/ManageTwoFactor" variant="contained" fullWidth>
						{!hasTwoFactorAuth ? 'Add Two Factor Auth' : 'Remove Two Factor Auth'}
					</Button>
				</Grid>
			</Grid>
		</Container>
	);
}

const mapStateToProps = state => ({
	Auth: state.Authentication,
});

const mapDispatchToProps = dispatch => ({
	PushHistory: data => dispatch(push(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Profile);

Profile.propTypes = {
	Auth: PropTypes.object,
	PushHistory: PropTypes.func,
};
